import React, { useState, useEffect } from 'react';
import { getSubscriptions } from '../../API/newsletterAPI';

const NewsletterSection = () => {
    const [subscriptions, setSubscriptions] = useState([]);

    useEffect(() => {
        const fetchSubscriptions = async () => {
            try {
                const data = await getSubscriptions();
                console.log(data.inquiries)
                setSubscriptions(data.subscriptions);  
            } catch (error) {
                console.error('Error fetching subscriptions:', error);
            }
        };
        
        fetchSubscriptions();
    }, []); 

    const formatDate = (dateString) => {
        const date = new Date(dateString);
    
        return date.toLocaleString('en-US', { 
            year: 'numeric', 
            month: '2-digit', 
            day: '2-digit', 
            hour: '2-digit', 
            minute: '2-digit', 
            second: '2-digit', 
            hour12: true 
        });
    };

    return (
        <div className="flex h-screen">
            <div className="flex-1 p-6">
                <div className="flex justify-between items-center border-b pb-4">
                    <h2 className="text-3xl font-bold">Newsletter Subscriptions</h2>
                </div>

                <div className="mt-6 overflow-x-auto">
                    <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-6 py-3 text-left text-md font-semibold text-gray-800">Email</th>
                                <th className="px-6 py-3 text-left text-md font-semibold text-gray-800">Created At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {subscriptions.map((subscription, index) => (
                                <tr key={index} className="border-t">
                                    <td className="px-6 py-3 text-sm text-gray-700">{subscription.email}</td>
                                    <td className="px-6 py-3 text-sm text-gray-700">{formatDate(subscription.created_date)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default NewsletterSection;
